var render = function render(){var _vm=this,_c=_vm._self._c;return _c('iframe',{staticStyle:{"width":"100%","height":"calc(100vh - 85px)","overflow-y":"scroll","border":"none","overflow":"hidden"},attrs:{"src":_vm.url,"frameborder":"0"}})
}
var staticRenderFns = []

export { render, staticRenderFns }